import * as z from "zod";
import { Id } from "./ids.js";

export const MINI_APP_MAX_BYTES = 512 * 1024;
export const MiniAppValues = z
  .preprocess(
    (value, ctx) => {
      if (
        value &&
        typeof value === "object" &&
        ["__proto__", "prototype", "constructor"].some((k) => Object.hasOwn(value, k))
      )
        ctx.addIssue({ code: "custom", message: "Invalid app storage key." });
      return value;
    },
    z.record(
      z
        .string()
        .max(128)
        .refine((k) => !["__proto__", "prototype", "constructor"].includes(k)),
      z.string(),
    ),
  )
  .superRefine((value, ctx) => {
    if (
      Object.keys(value).length > 256 ||
      new TextEncoder().encode(JSON.stringify(value)).length > MINI_APP_MAX_BYTES
    )
      ctx.addIssue({ code: "custom", message: "App storage is limited to 256 keys and 512 KB." });
  });
export type MiniAppValues = z.infer<typeof MiniAppValues>;
export const MiniAppSnapshot = z.object({
  values: MiniAppValues,
  revision: z.number().int().nonnegative(),
  updatedAt: z.string().nullable(),
});
export type MiniAppSnapshot = z.infer<typeof MiniAppSnapshot>;
export const MiniAppRead = z.object({ artifactId: Id });
export const MiniAppWrite = MiniAppRead.extend({
  values: MiniAppValues,
  revision: z.number().int().nonnegative(),
  mutationId: z.string().uuid(),
});
export type MiniAppWrite = z.infer<typeof MiniAppWrite>;
